import React from 'react';
// Chakra Imports
import {
    Avatar,
    Flex,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Text,
    Button,
    useColorModeValue,
    IconButton,
    useDisclosure,
    Icon,
    Image,
    Spinner,
    Link
} from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
// Custom Components
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';

// Assets
import routes from 'routes.js';
import { MdRefresh } from 'react-icons/md';
import { FaUserPlus } from 'react-icons/fa';
// Actions
import { logout } from 'actions/userActions';
import InviteModal from 'components/Model/InviteModal';
import { useGetWalletBalanceQuery } from 'reducers/dashboard.service';
import polygon from 'assets/img/polygon.png';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import BulkInviteModel from 'components/Model/BulkInviteModel';
import { LENDER_TYPE , REALTOR_TYPE } from 'constants/index';

const Polygon = ()=>{
    return (
        <Image src={polygon} boxSize={4} mr={1} verticalAlign="middle" />
    );
};

export default function HeaderLinks(props) {
    // Chakra Color Mode
    let menuBg = useColorModeValue('white', 'navy.800');
    const inviteOthersContext = useDisclosure();
    const [file , setfile] = React.useState(null);
    const [selectedType, setselectedType] = React.useState(null);
    const [open , setopen] = React.useState(false);

    const { onOpen } = inviteOthersContext;
    const invitOthers = ()=>{
        onOpen();
    };
    const textColor = useColorModeValue('secondaryGray.900', 'white');
    const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
    const shadow = useColorModeValue(
        '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
        '14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
    );
    const dispatch = useDispatch();
    const user = useSelector(state => state.userReducer.user);
    const { data, refetch, isLoading, isFetching } = useGetWalletBalanceQuery(undefined , {
        skip: false,
        refetchOnMountOrArgChange: true
    });
    const balance = data?.balance ? parseFloat(data?.balance).toFixed(3) : 0;
    const handleInvite = (USERTYPE)=>{
        setopen(!open);
        setfile(null);

        if (USERTYPE) {
            setselectedType(USERTYPE);
        } else {
            setselectedType(null);
        }
    };

    return (
        <Flex
            w={{ sm: '100%', md: 'auto' }}
            alignItems="center"
            flexDirection="row"
            bg={menuBg}
            flexWrap={'unset'}
            p="10px"
            borderRadius="30px"
        >
            <SidebarResponsive routes={routes} />
            <InviteModal
                {...inviteOthersContext}
            />
            <BulkInviteModel
                open={open}
                selectedType={selectedType}
                setopen={setopen}
                file={file}
                setfile={setfile}
            />
            <Menu>
                <Button mr={2} borderRadius={'1.5rem'} onClick={()=>handleInvite(LENDER_TYPE)} colorScheme='blue'>
                        Send Bulk Invite Lender
                </Button>

                <Button mr={2} borderRadius={'1.5rem'} onClick={()=> handleInvite(REALTOR_TYPE)} colorScheme='blue'>
                        Send Bulk Invite Realtor
                </Button>

                <Flex mr={2} gap={0.2} bg={'#E6E6FA'} pt={2} pb={2} pl={3} pr={3} borderRadius={'2rem'} justifyContent={'start'} alignItems={'center'}>

                    <Icon as={Polygon} w={6} h={4} mr={1} />
                    {
                        (isLoading || isFetching) ? <Spinner size='md'/> : balance}
                    <p>
                        &nbsp;
                        MATIC
                    </p>
                    <IconButton width={'1rem'} height={'1rem'} onClick={refetch} cursor={'pointer'} bgColor={'transparent'} >
                        <Icon as={MdRefresh} w={6} h={4} />
                    </IconButton>
                    <Link mb={1} target='__blank' href={'https://polygonscan.com/address/' + data?.walletAddress} >
                        <Icon as={ExternalLinkIcon} />
                    </Link>

                </Flex>
                &nbsp;
                <IconButton onClick={invitOthers} p={0} pr={10} bgColor={'transparent'} _active={{ bgColor: 'transparent' }} _hover={{ bgColor: 'transparent' }}>
                    <FaUserPlus size={35} color='var(--primary-color)'/>
                </IconButton>
                <MenuButton p="0px">
                    <Avatar
                        _hover={{ cursor: 'pointer' }}
                        color="white"
                        name={user.username}
                        bg="#11047A"
                        size="sm"
                        w="40px"
                        h="40px"
                    />
                </MenuButton>
                <MenuList
                    boxShadow={shadow}
                    p="0px"
                    mt="10px"
                    borderRadius="5px"
                    bg={menuBg}
                    border="none"
                >
                    <Flex w="100%" mb="0px">
                        <Text
                            ps="20px"
                            pt="16px"
                            pb="10px"
                            w="100%"
                            borderBottom="1px solid"
                            borderColor={borderColor}
                            fontSize="sm"
                            fontWeight="700"
                            color={textColor}
                        >
              👋&nbsp; Hey, {user.username}
                        </Text>
                    </Flex>
                    <Flex flexDirection="column" p="10px">
                        <MenuItem
                            _hover={{ bg: 'none' }}
                            _focus={{ bg: 'none' }}
                            color="red.400"
                            borderRadius="8px"
                            px="14px"
                            onClick={() => dispatch(logout())}
                        >
                            <Text fontSize="sm">Log out</Text>
                        </MenuItem>
                    </Flex>
                </MenuList>
            </Menu>
        </Flex>
    );
}

HeaderLinks.propTypes = {
    variant: PropTypes.string,
    fixed: PropTypes.bool,
    secondary: PropTypes.bool,
    onOpen: PropTypes.func
};
